<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-card>
            <div slot="header">
                <strong>Search IBO / Stockist</strong>
            </div>
            <b-row>
                <b-col sm="2">
                    <b-form-group>
                        <label>Warehouse</label>
                            <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="from_location_id" />
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label for="customer">IBO / Stockist</label>
                        <memberLookup v-bind:url="apiMemberLookupUrl" v-on:selected="setMember($event)" :lookupId="filter.customer_id"  />
                    </b-form-group>
                </b-col>
                <b-col sm="2">
                        <b-form-group>
                            <label for="date_start">Date Start</label>
                                <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                        </b-form-group>
                </b-col>
                <b-col sm="2">
                    <b-form-group>
                        <label for="date_end">Date End</label>
                            <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="1">
                    <b-form-group>
                        <label for="delivery method">Delivery Method</label>
                        <b-form-select id="status" v-model="filter.delivery_method":plain="true" :options="['','DELIVERY', 'SELF PICK-UP']">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="2">
                    <b-form-group>
                        <label for="status">Delivery Status</label>
                            <b-form-select id="status" v-model="filter.delivery_status"
                                :plain="true"
                                :options="['','PENDING', 'PICKING', 'PARTIAL-IN-TRANSIT','IN-TRANSIT','DELIVERED']"
                                value="">
                            </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="footer">
                <b-button type="submit" size="lg" variant="primary" @click="search" :disabled = "from_location_id == ''">Search</b-button>
            </div>
        </b-card>
        <b-row v-if= "pickListInfo.length > 0 && !loading">
            <b-col sm="12" >
                <b-card>
                    <div slot="header">
                        <strong>Picking List Info</strong>
                    </div>
                    <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="pickListInfoFields" :current-page="currentPickPage"
                        :per-page="perPage" :items="pickListInfo" @row-clicked="pickListDetails">
                    </b-table>
                    <nav>
                        <b-pagination :total-rows="getRowCount(pickListInfo)" :per-page="perPage" v-model="currentPickPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                </b-card>
                <div v-if="0">
                    {{pickListInfo}}
                </div>
            </b-col>
        </b-row>
        <b-row v-if ="searchResults.length > 0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>Sales Invoices</strong>
                    </div>
                    <b-row v-if="0">
                        <b-col sm="8">
                            <b-form-group label="Generate Picking List From (Warehouse)" label-for="horizEmail" :label-cols="4" :horizontal="true">
                                <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="from_location_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <div class = "table-responsive">
                                <table class='table table-striped'>
                                    <thead>
                                            <th>Trans Date</th>
                                            <th>Sales Docs No</th>
                                            <th>Invoice No</th>
                                            <th>IBO/Stockist No</th>
                                            <th>IBO/Stockist Name</th>
                                            <th>Channel</th>
                                            <th>Trans. Loc</th>
                                            <th>Delivery Method</th>
                                            <th>Delivery Town</th>
                                            <th>Status</th>
                                            <th style="padding:20px" v-if="sales_transactions.length >0">
                                            <label class="checkContainer">
                                                <input type="checkbox" v-model="selectAll" @click="select">
                                                    <span class="checkmark"></span>
                                            </label>
                                            </th>
                                        <th></th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row,index in searchResults">
                                            <td>{{row.trans_date}}</td>
                                            <td>{{row.sales_doc_num}}</td>
                                            <td>{{row.inv_number}}</td>
                                            <td>{{row.customer_id}}</td>
                                            <td>{{row.customer_name}}</td>
                                            <td>{{row.channel}}</td>
                                            <td>{{row.trans_loc}}</td>
                                            <td>{{row.delivery_method}}</td>
                                            <td>{{row.delivery_town}}</td>
                                            <td>{{row.status}}</td>
                                            <td style="padding:20px">
                                                <label class="checkContainer"  v-if ="row.status == 'PENDING' && from_location_id != ''">
                                                    <input type="checkbox" v-model="selectedSalesDoc" :value="row.sales_doc_num">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-col>
                    </b-row>
                    <div class = "table-responsive" v-if="0">
                        <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults">
                                <template slot="check_box" slot-scope = "row">
                                    <label class="checkContainer"  v-if ="row.item.status == 'PENDING' && from_location_id != ''">
                                        <input type="checkbox" v-model="selectedSalesDoc" :value="row.item.sale_id">
                                        <span class="checkmark"></span>
                                    </label>
                                </template>
                            <template slot = "wsi_entry" slot-scope = "row">
                                <b-button size="md" @click="rowClick(row.item)" variant="success" :disabled="row.item.delivery_status_name != 'PENDING'"> >> </b-button>
                            </template>
                        </b-table>
                        <nav v-if="0">
                            <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                        </nav>
                    </div>
                    <div v-if="0">{{selectedSalesDoc}}</div>
                <b-row>
                    <b-button type="submit" size="lg" variant="primary" @click="confirmGeneratePickingList" v-if="selectedSalesDoc.length > 0 ">Generate Picking List</b-button>
                    <b-modal v-model="modalShow" @ok="generatePickingList" @cancel="handleCancel" hide-header-close title="Confirm Generate Picking List"  centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                        Confirmed Generate?
                    </b-modal>
                </b-row>

                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading" >
            <b-col sm="12">
              <div align="center">
                <strong>No Records Found</strong>
              </div>
            </b-col>
        </b-row>
        <div>
            <b-modal v-model="errorModal" hide-header-close title="Alert" ok-only ok-variant="secondary" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
               The number of invoices allowed for one pickinglist is up to <b>10</b>.
            </b-modal>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import memberLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup, apiWsiSearch, apiGeneratePickingList , apiMemberLookup,apiWarehouseLookup} from '@/functions/common.vue'

export default
{
    components:{ spinner,memberLookup,warehouseLookup },
    created()
    {
      console.log(authHeader())
    },
    props: {
      caption:
      {
        type: String,
        default: 'Table'
      },
      hover:
      {
        type: Boolean,
        default: false
      },
      striped:
      {
        type: Boolean,
        default: false
      },
      bordered:
      {
        type: Boolean,
        default: false
      },
      small:
      {
        type: Boolean,
        default: false
      },
      fixed:
      {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        apiMemberLookupUrl: apiMemberLookup,
        apiWarehouseUrl : apiWarehouseLookup,
        loading: false,
        selectAll:false,
        noResults: false,
        errorModal:false,
        modalShow: false,
        from_location_id:'',
        transactions_filter:{
            trans_date:'',
            status:'',
        },
        sales_transactions:[],
        filter:
          {
            customer_id: '',
            date_start: '',
            date_end: '',
            delivery_method:'',
            delivery_status:''
          },
        pickListInfo: [],
        selectedSalesDoc:[],
        transactions:[],
        transactionsFields:[
            {key: 'trans_date', label: 'Date'},
            {key: 'status', label: 'Status'}
        ],
        pickListInfoFields:
        [
            {key: 'picking_list_date', label: 'Pick Date'},
            {key: 'picking_list_num' ,label: 'Pick List No'},
            {key: 'author_user_shortname' ,label: 'Created By'},
        ],
        searchResults: [],
        searchResultsFields:
        [
            {key: 'trans_date', label: 'Trans Date'},
            {key: 'sales_doc_num' ,label: 'Sales Docs No'},
            {key: 'inv_number' ,label: 'Invoice No'},
            {key: 'customer_id' ,label: 'IBO/Stockist No'},
            {key: 'customer_name' ,label: 'IBO/Stockist Name'},
            {key: 'channel' ,label: 'Channel'},
            {key: 'trans_loc' ,label: 'Trans. Loc'},
            {key: 'delivery_method' ,label: 'Delivery Method'},
            {key: 'delivery_town' ,label: 'Delivery Town'},
            {key: 'status',label: 'Status'},
            {key: 'check_box',label :' ','class': 'text-center'},
            {key: 'wsi_entry',label :' ','class': 'text-center'},
        ],
        currentPage: 1,
        currentPickPage:1,
        perPage: 10,
        totalRows: 0,
        noResults: false
      }
    },
    watch: {
    selectedSalesDoc (newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.selectAll = false
      } else if (newVal.length === this.sales_transactions.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    }
  },
    methods:
    {
        select()
        {
			this.selectedSalesDoc = [];
			if (!this.selectAll) {
				for (let i in this.searchResults) {
                    if(this.searchResults[i].status == "PENDING")
                    {
                        this.selectedSalesDoc.push(this.searchResults[i].sales_doc_num);
                    }
				}
			}
		},
        setWarehouse(obj)
        {
            if(!this.lockEntry)
            {
                var id

                if (obj !== null)
                {
                    if (obj.id != this.location_id)
                    {
                        this.selectedSalesDoc = []
                    }
                    id = obj.id
                }
                else
                {
                    id = ""
                }
                this.from_location_id = id
            }
        },
    setMember(obj)
    {
        var id
        if (obj !== null)
        {
            id = obj.id
        }
        else
        {
            id = null
        }
        this.filter.customer_id = id
    },
    pickListDetails(item, index)
    {
        this.$router.push({ name: 'Picking List Info', params: { picklistNum: item.picking_list_num }})
    },
    searchTransactions()
    {
        var sf =
        [
            "trans_date <= " + this.transactions_filter.trans_date
            ,"status = " + this.transactions_filter.status
        ]
    },
    getRowCount (items)
    {
        return items.length
    },
    search()
    {
        this.loading = true
        this.noResults = true
        this.selectedSalesDoc = []
        var sf =
        {
            user_id:this.filter.customer_id,
            from_date:this.filter.date_start,
            to_date:this.filter.date_end,
            from_location_id:this.from_location_id,
            delivery_method_name:this.filter.delivery_method,
            delivery_status_name:this.filter.delivery_status
        }
         axios.post(apiWsiSearch, sf,authHeader())
        .then (res =>
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.sales

                const pickList = data.data.data.picking_list
                for(let p in pickList)
                {
                    var picking_list_date = pickList[p].picklist_date
                    if(picking_list_date == '')
                    {
                        picking_list_date = '-'
                    }
                    else
                    {
                        var pickDate = new Date(picking_list_date)
                        picking_list_date  = "" + (pickDate.getDate() > 9 ? '' : '0') + pickDate.getDate() + '/'+  ((pickDate.getMonth() + 1) > 9 ? '' : '0') + (pickDate.getMonth() + 1) + '/' + pickDate.getFullYear()+" " + (pickDate.getHours() > 9 ? '' : '0') + pickDate.getHours() + ":" + (pickDate.getMinutes() > 9 ? '' : '0') + pickDate.getMinutes() + ":" + (pickDate.getSeconds() > 9 ? '' : '0') + pickDate.getSeconds()
                    }

                    pickList[p].picking_list_date = picking_list_date
                    pickList[p].picking_list_num = pickList[p].picklist_num
                    pickList[p].author_user_shortname = pickList[p].author_user_shortname
                    this.pickListInfo.push(pickList[p])
                }
                this.pickListInfo = data.data.data.picking_list

                for (let key in myData)
                {
                    var date = myData[key].transaction_date
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].trans_date=result
                    myData[key].sales_doc_num = myData[key].document_number
                    myData[key].customer_id = myData[key].old_member_id
                    myData[key].customer_name = myData[key].member_name
                    myData[key].channel = myData[key].channel_name
                    myData[key].trans_loc = myData[key].transaction_location_name
                    myData[key].delivery_method = myData[key].delivery_method_name
                    myData[key].sale_id = myData[key].document_number
                    myData[key].delivery_town = myData[key].delivery_town_name
                    myData[key].status = myData[key].delivery_status_name
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                for(var k in this.searchResults)
                {
                    if(this.searchResults[k].status == "PENDING")
                    {
                        this.sales_transactions.push(this.searchResults[k])
                    }
                }
                if(this.searchResults.length == 0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => console.log(error))
        },
        confirmGeneratePickingList()
        {
            this.modalShow = true
        },
        generatePickingList()
        {

            var item = this.selectedSalesDoc

            if(item.length <= 10)
            {
                this.loading = true
                axios.post(apiGeneratePickingList,{sales_invoices_num:this.selectedSalesDoc,from_location_id:this.from_location_id} ,authHeader())
                .then(res =>
                {
                    var data = res.data.data
                    var picking_list_date = data.picking_list_date
                    if(picking_list_date  == null)
                    {
                        picking_list_date = '-'
                    }
                    else
                    {
                        var pickDate = new Date(picking_list_date)
                        picking_list_date  = "" + (pickDate.getDate() > 9 ? '' : '0') + pickDate.getDate() + '/'+  ((pickDate.getMonth() + 1) > 9 ? '' : '0') + (pickDate.getMonth() + 1) + '/' + pickDate.getFullYear()+" " + (pickDate.getHours() > 9 ? '' : '0') + pickDate.getHours() + ":" + (pickDate.getMinutes() > 9 ? '' : '0') + pickDate.getMinutes() + ":" + (pickDate.getSeconds() > 9 ? '' : '0') + pickDate.getSeconds()
                    }
                    data.picking_list_date = picking_list_date

                    this.$router.push({ name: 'Picking List Info', params: { picklistNum: data.picking_list_num }})

                    // this.pickListInfo.push(data)
                    // this.search()
                })
                .catch(error => {
                  console.log(error)
                  this.loading = false
                })

                this.selectedSalesDoc = []
            }
            else
            {
                this.errorModal = true
            }


        },
        handleCancel()
        {
            this.selectedSalesDoc = []
        },
        rowClick(row)
        {
            this.selectedSalesDoc.push(row.document_number)
            this.modalShow = true
        }
    }
}
</script>
<style>
.main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}

.checkContainer {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  background-color: #C0C0C0;
}

/* On mouse-over, add a grey background color */
.checkContainer:hover input ~ .checkmark {
  background-color: #ffffff;
}

/* When the checkbox is checked, add a blue background */
.checkContainer input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkContainer input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.checkContainer .checkmark:after {
  left: 7px;
  top: 4px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/views/wsi/wsis.vue